import { pick } from 'lodash-es'

import { getFormValue } from '../utils'
import { getAmountWithSymbol } from './helpers'

const getHasActivePaymentMethod = (
  isUpgradeRequired,
  eventType,
  formValues,
  isPaypalPpcpFeatureVariation = false
) => {
  const {
    is_stripe_connected: isStripeConnected,
    is_paypal_connected: isPaypalConnected,
    is_paypal_ppcp_connected: isPaypalPpcpConnected,
  } = eventType
  const { provider } = formValues

  if (!provider) { return undefined }

  const isPaypalPpcpConnectionActive = isPaypalPpcpFeatureVariation && isPaypalPpcpConnected
  const isProviderConfigurationRequired = provider === 'none'
    && !isStripeConnected
    && !isPaypalConnected
    && !isPaypalPpcpConnectionActive
  const isPaymentSelectorVisible = !isUpgradeRequired && !isProviderConfigurationRequired
  const hasActivePaymentMethod = isPaymentSelectorVisible && provider !== 'none'

  return hasActivePaymentMethod
}

export const prepareValuesForPreview = (eventType, formValues, isUpgradeRequired, isPaypalPpcpFeatureVariation = false) => {
  const { currency, amount } = formValues

  if (currency === undefined) {
    return pick(eventType, ['payment_method', 'has_active_payment_method'])
  }

  return {
    has_active_payment_method: getFormValue(
      eventType.has_active_payment_method,
      getHasActivePaymentMethod(isUpgradeRequired, eventType, formValues, isPaypalPpcpFeatureVariation)
    ),
    payment_method: {
      ...eventType.payment_method,
      currency,
      amount_with_symbol: getAmountWithSymbol({ currency, amount })
    }
  }
}
